import { useBookingModalContext } from "../contexts/Modals";
import { useGamesContext } from "../contexts/Games";

import { adminBookGame, adminBookPlaceholder } from "../../../../lib/api";
import { IGame, IUmpire } from "../../../../types/api";

export const useButtonHandlers = () => {
    const {
        setBookingModalContent,
        setShowBookingModal,
        setBookingStatus,
        setBookingStatusMessage,
    } = useBookingModalContext();
    const { setGames } = useGamesContext();

    const handleBookingClick = (
        game: IGame,
        location: IUmpire["location"],
        umpire?: IUmpire,
        pendingReplacementUmpire?: IUmpire,
    ) => {
        setBookingModalContent({
            game,
            location,
            umpire,
            pendingReplacementUmpire,
        });
        setShowBookingModal(true);
    };

    const handleBookingConfirmClick = async (
        game: IGame,
        location: IUmpire["location"],
        newUmpire?: IUmpire["id"],
        removeUmpire?: number,
        postForReplacement: boolean = false,
        cancelReplacement: boolean = false,
        currentUmpire?: IUmpire,
        overrideDoubleBooking: boolean = false,
    ) => {
        const isGameBooking = game.id !== null;

        setBookingStatus("pending");
        const action = isGameBooking
            ? adminBookGame(
                  game.id,
                  location,
                  newUmpire,
                  removeUmpire,
                  postForReplacement,
                  cancelReplacement,
                  currentUmpire,
                  overrideDoubleBooking,
              )
            : adminBookPlaceholder(
                  game.league,
                  game.date,
                  game.endDate,
                  game.ageLevel.id,
                  game.fieldId,
                  game.diamond,
                  location,
                  newUmpire,
                  removeUmpire,
                  postForReplacement,
                  cancelReplacement,
                  currentUmpire,
                  overrideDoubleBooking,
              );

        await action
            .then(response => {
                const { game } = response;
                if (isGameBooking) {
                    setGames(prev =>
                        prev.map(g => (g.id === game.id ? game : g)),
                    );
                } else {
                    setGames(prev => {
                        return prev.map(g => {
                            if (
                                g.league === game.league &&
                                g.date === game.date &&
                                g.endDate === game.endDate &&
                                g.ageLevel.id === game.ageLevel.id &&
                                g.fieldId === game.fieldId &&
                                g.diamond === game.diamond
                            ) {
                                return game;
                            } else {
                                return g;
                            }
                        });
                    });
                }
                const thisUmpire = game.umpires?.find(
                    u => u.location === location,
                );
                setBookingModalContent({ game, location, umpire: thisUmpire });
                setBookingStatus("success");
                setBookingStatusMessage(
                    "Success! The umpires for this game have been updated.",
                );
            })
            .catch(e => {
                setBookingStatus("failed");
                setBookingStatusMessage(`This game could not be booked: ${e}`);
                throw new Error(e);
            });
    };

    return { handleBookingClick, handleBookingConfirmClick };
};
